/**
 * Where each of the reader's books stands against its term.
 *
 * Purchases are term-limited on the platform — every book is licensed for a
 * number of months — and may be renewed from a month before that term ends, or
 * at any time after. The platform holds that record, not this store; the
 * backend asks it on the reader's behalf (GET /api/library).
 *
 * Each entry: {book_id, book_title, expiry_date, is_expired, renewable,
 * renewal_opens_at, additional_languages}, plus where it stands among the book's
 * versions — {lineage_id, version_number, latest_version, latest_book_id,
 * update_available} — and whether a language can be added now —
 * {addon_window_open, addon_term_fraction}.
 *
 * `book_id` is the version the reader holds. The catalogue lists only the latest
 * version, so match a product to an entry with findEntry below, never by id alone.
 */

import { USE_MOCKS } from '@/config';
import { delay, request } from './client';

export async function listLibrary({ signal } = {}) {
  if (USE_MOCKS) {
    // The bundled mock has no platform behind it, so nothing it sells expires
    // and nothing is ever up for renewal.
    await delay(120);
    return [];
  }
  return request('/api/library', { signal });
}

/** The reader's purchase of `product` — of any version of it — or null. */
export function findEntry(entries, product) {
  if (!product) return null;
  return (
    entries.find((e) => e.book_id === product.id) ??
    entries.find((e) => product.lineage_id && e.lineage_id === product.lineage_id) ??
    null
  );
}
